export default "__VITE_ASSET__Cv1Sb_Am__"